import { render, staticRenderFns } from "./tx-form.vue?vue&type=template&id=0e466352&lang=html&"
import script from "./tx-form.vue?vue&type=script&lang=js&"
export * from "./tx-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports